var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.86,
    height: 20.32,
    viewBox: "0 0 22.86 20.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-signature",
    "data-name": "Icon awesome-file-signature",
    d: "M8.659,16.833a.44.44,0,0,0-.4-.259.433.433,0,0,0-.4.246l-.3.609a.635.635,0,0,1-1.17-.083l-.668-2-.421,1.265A1.713,1.713,0,0,1,3.667,17.78H3.175a.635.635,0,1,1,0-1.27h.492a.445.445,0,0,0,.422-.3l.722-2.169a.953.953,0,0,1,1.808,0L7.17,15.69a1.781,1.781,0,0,1,2.619.562.45.45,0,0,0,.371.248V13.241L15.241,8.2V6.35h-5.4A.955.955,0,0,1,8.89,5.4V0H.953A.95.95,0,0,0,0,.953V19.368a.95.95,0,0,0,.953.953H14.288a.95.95,0,0,0,.953-.953V17.78l-5.08,0A1.7,1.7,0,0,1,8.659,16.833Zm6.581-12a.949.949,0,0,0-.278-.671L11.077.278A.952.952,0,0,0,10.4,0H10.16V5.08h5.08ZM11.43,13.77v2.74h2.738l6.417-6.46L17.891,7.356,11.43,13.77ZM22.564,6.641,21.3,5.376a1.011,1.011,0,0,0-1.429,0L18.789,6.458l2.694,2.694L22.564,8.07A1.01,1.01,0,0,0,22.564,6.641Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.f804035f2a61bb6b19c2342b070db336.svg";
export { ForwardRef as ReactComponent };